import { ActionCreator, createAction, on } from '@ngrx/store';
import { EntityState } from '@ngrx/entity';
import { LoadingStatus } from '@qvs/core';

export const createLoadingStatusActionGroup = (prefix: string, resource: string) => ({
  load: createAction(`${prefix} load ${resource}`),
  success: createAction(`${prefix} load ${resource} success`),
  failure: createAction(`${prefix} load ${resource} failure`)
});

export const createLoadingStatusActionGroupWithParameter = <P>(prefix: string, resource: string) => ({
  load: createAction(`${prefix} load ${resource}`, (payload: P) => ({ payload })),
  success: createAction(`${prefix} load ${resource} success`),
  failure: createAction(`${prefix} load ${resource} failure`)
});

export const createLoadingStatusActionGroupWithResponse = <R>(prefix: string, resource: string) => ({
  load: createAction(`${prefix} load ${resource}`),
  success: createAction(`${prefix} load ${resource} success`, (response: R) => ({ response })),
  failure: createAction(`${prefix} load ${resource} failure`)
});

export const onEntityLoadingStatus = <S extends EntityState<unknown>>(
  load: ActionCreator,
  success: ActionCreator,
  failure: ActionCreator
) => [
  on<S, [typeof load]>(load, (state) => ({
    ...state,
    loadingStatus: LoadingStatus.LOADING
  })),
  on<S, [typeof success]>(success, (state) => ({
    ...state,
    loadingStatus: LoadingStatus.SUCCEEDED
  })),
  on<S, [typeof failure]>(failure, (state) => ({
    ...state,
    loadingStatus: LoadingStatus.FAILED
  }))
];

export const onNestedLoadingStatus = <S extends EntityState<unknown>>(
  load: ActionCreator,
  failure: ActionCreator,
  nestedKey: keyof S
) => [
  on<S, [typeof load]>(load, (state) => {
    const newState = { ...state };
    (newState as S)[nestedKey] = {
      ...(state as S)[nestedKey],
      loadingStatus: LoadingStatus.LOADING
    };
    return newState;
  }),
  on<S, [typeof failure]>(failure, (state) => {
    const newState = { ...state };
    (newState as S)[nestedKey] = {
      ...(state as S)[nestedKey],
      loadingStatus: LoadingStatus.FAILED
    };
    return newState;
  })
];
